import {
  ErrorComponent,
  ForgotPasswordComponent,
  HomeComponent,
  LoginComponent,
  RegisterComponent,
  ResetPasswordComponent,
} from './views';
import { AppRoutes } from './app.routes';
import { AppComponent } from './app.component';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { MomentModule } from 'angular2-moment';
import { TabsModule } from 'ngx-bootstrap/tabs';
//import { CookieService } from 'angular2-cookie';
import { UserService } from './core/services/user';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { GDPRService } from './core/services/rulebook';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { HttpClientModule } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatSelectModule } from '@angular/material/select';

import { HelpComponent } from './views/help/help.component';
import { AuthGuard } from './core/services/auth/auth.guard';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LibraryModule } from './views/library/library.module';
import { PositioningService } from 'ngx-bootstrap/positioning';
import { RegulationService } from './core/services/regulation';
import { AuthService } from './core/services/auth/auth.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, SecurityContext } from '@angular/core';
import { SharedUIModule } from './views/shared/shared-ui.module';
import { FooterComponent, NavbarComponent } from './views/shared';
import { PagerService, PwaService } from './core/services/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonService } from './core/services/common/common.service';
import { SessionService } from './core/services/auth/session.service';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChangeViewerModule } from './views/change-viewer/change-viewer.module';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { ActionDetailComponent } from './views/action-detail/action-detail.component';
import { AuthCallbackComponent } from './views/auth-callback/auth-callback.component';
import { SelfAssessmentModule } from './views/self-assessment/self-assessment.module';
import { UserManagementModule } from './views/user-management/user-management.module';
import { ErrorMessageComponent } from './views/error-message/error-message.component';
import { PrivacyPolicyComponent } from './views/privacy-policy/privacy-policy.component';
import { PublishReportComponent } from './views/publish-report/publish-report.component';
import { ImpactAssessmentModule } from './views/impact-assessment/impact-assessment.module';
import { DistributedUIModule } from './views/distributed-ui-components/distributed-ui.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { groupingReducer } from './state/grouping/grouping.reducer';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipsModule, MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { CookieService } from 'ngx-cookie-service';
import { LibraryRoutes } from './views/library/library.route';
import { NewRulebookPrimengComponent } from './views/shared/new-rulebook-primeng/new-rulebook-primeng.component';
import { PlanType } from './core/enums/user';
import { MyReuseStrategy } from './views/shared/my-reuse-strategy';
import { RulebookVersionDialogComponent } from './views/rulebook-version-dialog/rulebook-version-dialog.component';
import { ButtonModule } from 'primeng/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import { RiskControlsComponent } from './views/risk-controls/risk-controls.component';
import { AddEditRiskControlsComponent } from './views/add-edit-risk-controls/add-edit-risk-controls.component';
import { FilterRiskControlComponent } from './views/filter-risk-control/filter-risk-control.component';
import { RegulatoryInsightsGeneratorComponent } from './views/regulatory-insights-generator/regulatory-insights-generator.component';
import {AvatarModule} from 'primeng/avatar';
import {DialogModule} from 'primeng/dialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BadgeInfo, Clipboard, LucideAngularModule, MoveLeft, MoveRight, Sparkles, SquarePen, ZoomIn, ZoomOut,ListChecks,X,Ellipsis, Share, Pencil, Trash2 } from 'lucide-angular';
import { MarkdownModule } from 'ngx-markdown';
import { SkeletonModule } from 'primeng/skeleton';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {MatMenuModule} from '@angular/material/menu';
import { SidebarModule } from 'primeng/sidebar';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavbarComponent,
    ActionDetailComponent,
    ErrorComponent,
    ForgotPasswordComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    AuthCallbackComponent,
    HelpComponent,
    ErrorMessageComponent,
    PrivacyPolicyComponent,
    PublishReportComponent,
    RulebookVersionDialogComponent,
    RiskControlsComponent,
    AddEditRiskControlsComponent,
    FilterRiskControlComponent,
   RegulatoryInsightsGeneratorComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    MatNativeDateModule,
    MatChipsModule,
    MatDatepickerModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    RouterModule.forRoot(AppRoutes, { useHash: false }),
    HttpClientModule,
    MomentModule,
    MatButtonModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    DistributedUIModule,
    ScrollingModule,
    TooltipModule,
    BsDropdownModule,
    TabsModule.forRoot(),
    CollapseModule.forRoot(),
    SharedUIModule,
    LibraryModule,
    UserManagementModule,
    ChangeViewerModule,
    ImpactAssessmentModule,
    SelfAssessmentModule,
    ButtonModule,
    MatTooltipModule,
    AvatarModule,
    DialogModule,
    PdfViewerModule,
    SkeletonModule,
    ProgressSpinnerModule,
    MatMenuModule,
    MarkdownModule.forRoot({
      sanitize: SecurityContext.NONE
    }),
    SidebarModule,
    LucideAngularModule.pick({SquarePen, Sparkles,ZoomIn,ZoomOut, MoveLeft, MoveRight, Clipboard, BadgeInfo,ListChecks, X, Ellipsis, Share, Pencil, Trash2 }),
    StoreModule.forRoot({ grouping: groupingReducer }),
    environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 60, logOnly: true }),
    
  ],
  providers: [
    CookieService,
    AuthService,
    SessionService,
    UserService,
    RegulationService,
    AuthGuard,
    PagerService,
    PwaService,
    GDPRService,
    AnalyticsService,
    PositioningService,
    ComponentLoaderFactory,
    CommonService,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: { separatorKeyCodes: [ENTER, COMMA] },
    },
    { provide: RouteReuseStrategy, useClass: MyReuseStrategy },
    {
      provide: MatDialogRef,
      useValue: {}
    }, {
      provide: MAT_DIALOG_DATA,
      useValue: {} // Add any data you wish to test if it is passed/used correctly
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
